import React from 'react';
import CommonUtil from "../../utils/CommonUtil";

export type OZHViewerProp = {
    reportName: string;
    style?: React.CSSProperties;
    className?: string;
    parameter: any;
}
export default class OZHViewer extends React.Component<OZHViewerProp> {

    private readonly style: OZHViewerProp["style"];
    private readonly className: OZHViewerProp["className"];
    private readonly parameter: OZHViewerProp["parameter"];
    private readonly reportName: OZHViewerProp["reportName"];
    private readonly OZViewerID:string;
    private readonly start_ozjs:any;

    constructor(props: OZHViewerProp) {
        super(props);
        this.reportName = props.reportName;
        this.parameter = props.parameter;
        this.style = props.style
        this.className = props.className;
        this.OZViewerID = CommonUtil.getUid();
        this.start_ozjs = window["start_ozjs"];
    }

    componentDidMount() {

        console.log("SetOZParameters_OZViewer", "OZViewerID", this.OZViewerID, `/${this.reportName}.ozr`);
        console.log("SetOZParameters_OZViewer", "parameter", this.parameter);

        window["SetOZParamters_" + this.OZViewerID] = () => {
            let oz: any = document.getElementById(this.OZViewerID);

            for (const key in this.parameter) {
                oz.sendToActionScript(key, this.parameter[key]);
            }

            oz.sendToActionScript("connection.servlet", "/oz80/server");
            oz.sendToActionScript("connection.reportname", `/${this.reportName}.ozr`);

            return true;
        }

        const opt = [];
        opt["print_exportfrom"] = "server"; // 인쇄시 서버로부터 PDF 생성
        opt["save_exportfrom"] = {"pdf": "server"}; // 저장시 서버로부터 PDF 생성

        this.start_ozjs(this.OZViewerID, "/external/ozhviewer/", opt);
    }

    render() {
        return (
            <div id={this.OZViewerID} style={this.style} className={this.className}/>
        )
    }
}
